import { setUser } from '@sentry/vue'
import { TOKEN_KEY } from '~/constants'
import type { User } from '~/types/users'
import type { ErrorApiResponse } from '~/types'

export const useUser = () => {
  const authStore = useAuthStore()
  return authStore.getIsLoggedIn ? authStore.getUser : null
}

export const useGoogleLogin = () => {
  const config = useRuntimeConfig()

  return navigateTo(`${config.public.API_URL}auth/oauth/login?redirect=${config.public.APP_URL}`, {
    external: true,
  })
}

export const useLogin = async (email: string, password: string) => {
  const { $api } = useNuxtApp()
  const authStore = useAuthStore()
  const token = useStatefulCookie(TOKEN_KEY)
  const { data, error } = await $api<{ data: { token: string; user: User }; error?: ErrorApiResponse }>('auth/login', {
    method: 'post',
    body: {
      email,
      password,
    },
  })

  if (error) {
    throw createError(error)
  }

  token.value = data.token as string
  authStore.setUser(data.user)
  useGetBranding()
  return data.user
}

export const useLogout = async () => {
  const { $api } = useNuxtApp()
  const authStore = useAuthStore()
  const brandingStore = useBrandingStore()
  const token = useStatefulCookie(TOKEN_KEY)

  return await $api<void>(`auth/logout`, {
    method: 'DELETE',
  }).finally(() => {
    token.value = null

    setUser(null)

    authStore.clearUser()
    brandingStore.clearBranding()
    localStorage.removeItem('ui')

    navigateTo('/')
  })
}
